import React, { useEffect } from 'react';

import { REQUIRED_RULE } from 'utils/constants';
import { countries } from 'utils/countries';
import { useUbigeo } from 'hooks/useUbigeo';

export default function SignupStepPersonal({
  buildBaseInput,
  setValue,
  watch,
  generalApi,
}: {
  buildBaseInput: any;
  setValue: any;
  watch: any;
  generalApi: any;
}) {
  const isPep = watch('pep');
  const country = watch('country');
  const department = watch('department');
  const province = watch('province');

  const [departments, provinces, districts] = useUbigeo(
    country !== 'PE',
    generalApi,
    department,
    province
  );

  useEffect(() => {
    setValue('province', provinces[0]);
  }, [provinces, setValue]);

  useEffect(() => {
    setValue('district', districts[0]);
  }, [districts, setValue]);

  return (
    <div className="grid grid-cols-3 gap-6 px-8 pt-8 pb-8">
      {buildBaseInput('Nombres *', 'text', 'name', REQUIRED_RULE, {})}
      {buildBaseInput('Apellido Paterno *', 'text', 'lname_p', REQUIRED_RULE, {})}
      {buildBaseInput('Apellido Materno *', 'text', 'lname_m', REQUIRED_RULE, {})}
      {buildBaseInput('Nacionalidad *', 'select', 'country', REQUIRED_RULE, {
        options: countries,
      })}
      {buildBaseInput('Dirección *', 'text', 'address', REQUIRED_RULE, {})}
      {buildBaseInput(
        'Región *',
        country === 'PE' ? 'select' : 'text',
        'department',
        REQUIRED_RULE,
        {
          options: departments.map((obj) => ({
            name: obj,
          })),
        }
      )}
      {buildBaseInput(
        'Provincia *',
        country === 'PE' ? 'select' : 'text',
        'province',
        REQUIRED_RULE,
        {
          options: provinces.map((obj) => ({
            name: obj,
          })),
        }
      )}
      {buildBaseInput(
        'Distrito *',
        country === 'PE' ? 'select' : 'text',
        'district',
        REQUIRED_RULE,
        {
          options: districts.map((obj) => ({
            name: obj,
          })),
        }
      )}
      {buildBaseInput('Ocupación *', 'text', 'job', REQUIRED_RULE, {})}
      {buildBaseInput('Correo electrónico *', 'email', 'email', REQUIRED_RULE, {})}
      {buildBaseInput('Celular *', 'text', 'cellphone', REQUIRED_RULE, {})}
      {buildBaseInput(
        'Teléfono',
        'text',
        'telephone',
        {},
        {
          helperText: '0 + Código de Ciudad + Número Telefónico',
        }
      )}
      {buildBaseInput('PEP', 'select', 'pep', REQUIRED_RULE, {
        helperText: 'Persona Expuesta Políticamente',
        options: [
          {
            name: 'Si',
          },
          {
            name: 'No',
          },
        ],
      })}

      {isPep === 'Si' ? (
        buildBaseInput('Institución *', 'text', 'pep_institute', REQUIRED_RULE, {})
      ) : (
        <div />
      )}
      {isPep === 'Si' ? (
        buildBaseInput('Fecha de Ingreso *', 'date', 'pep_since', REQUIRED_RULE, {})
      ) : (
        <div />
      )}
    </div>
  );
}
